





















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  CostLabor,
  CostsApi,
  CreateCostLaborRequest,
  GetWorkerCostLaborRequest,
  User,
  WorkorderPagedCollectionApiResponse,
  WorkordersApi
} from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {},
  computed: mapGetters({
    api: 'costsApi',
    ordersApi: 'ordersApi',
    performoUser: 'performoUser',
    currentPropertyId: 'currentPropertyId'
  })
})
export default class Timecard extends Vue {
  private api!: CostsApi;
  private ordersApi!: WorkordersApi;
  private performoUser!: User;
  private currentPropertyId!: string;
  private orderResponse!: WorkorderPagedCollectionApiResponse;
  private cmd!: CreateCostLaborRequest;
  private query!: GetWorkerCostLaborRequest;

  private loading = false;
  private menu = false;
  private dialog = false;
  private orderValidation = false;
  private deleteDialog = false;
  private loadingWeeklyCostLaborHours = false;

  private costLaborRecords: CostLabor[] = [];
  private laborHoursThisWeek = '0.00';
  private tcardTypes: string[] = [];
  private date!: string;
  private dateFormatted!: string;
  private editedIndex = -1;
  private editedItem: CostLabor = {
    laborDate: new Date(),
    tcardRecordType: '',
    orderNumber: '',
    laborHours: 0,
    tcardNotes: ''
  };
  private defaultItem: CostLabor = {
    laborDate: new Date(),
    tcardRecordType: '',
    orderNumber: '',
    laborHours: 0,
    tcardNotes: '',
    propertyId: ''
  };

  data() {
    return {
      date: this.date,
      dateFormatted: this.dateFormatted,
      menu: this.menu,
      dialog: this.dialog,
      loading: this.loading,
      loadingWeeklyCostLaborHours: this.loadingWeeklyCostLaborHours
    };
  }

  get timecardEntries() {
    if (this.costLaborRecords) {
      return this.costLaborRecords;
    }
    return undefined;
  }

  get timecardTypes() {
    if (this.tcardTypes) {
      this.tcardTypes?.splice(this.tcardTypes.indexOf('-'), 1);
      return this.tcardTypes;
    }
    return undefined;
  }

  get formattedDate() {
    return this.formatDate(this.date);
  }

  get formTitle() {
    return this.editedIndex === -1
      ? 'New Timecard Entry'
      : 'Edit Timecard Entry';
  }

  get totalHours() {
    var countHours = 0;
    this.costLaborRecords.forEach((element) => {
      if (element.laborHours) {
        countHours += element.laborHours;
      }
    });
    return countHours.toFixed(2);
  }

  get firstDayOfThisWeek() {
    let date = new Date(this.dateFormatted);
    let firstDayOfThisWeek = this.getFirstDayOfWeek(date);
    let month = firstDayOfThisWeek.getMonth() + 1;
    let dayOfMonth = firstDayOfThisWeek.getDate();
    return `${month}/${dayOfMonth}`;
  }

  get lastDayOfThisWeek() {
    let date = new Date(this.dateFormatted);
    let lastDayOfThisWeek = this.getLastDayOfWeek(date);
    let month = lastDayOfThisWeek.getMonth() + 1;
    let dayOfMonth = lastDayOfThisWeek.getDate();
    return `${month}/${dayOfMonth}`;
  }
  get clientSideValidation() {
    return (
      this.editedItem.laborHours &&
      this.editedItem.laborHours > 0 &&
      this.orderValidation
    );
  }

  private async mounted() {
    this.date = this.getDateInYYYYMMDD(new Date());

    this.loadLaborRecords();
    this.loadTcardTypes();
  }

  private getDateAdjustedForUTC(date: Date) {
    var adjustedDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    );

    return adjustedDate;
  }

  private async getTotalLaborHoursThisWeek() {
    this.loadingWeeklyCostLaborHours = true;
    let date = new Date(this.dateFormatted);
    let firstDayOfWeek = this.getFirstDayOfWeek(date);
    let thisDayOfWeek = new Date(date.getTime());
    let costLabors: CostLabor[] = [];
    for (let weekDayOffset = 0; weekDayOffset < 6; weekDayOffset++) {
      thisDayOfWeek.setTime(
        firstDayOfWeek.getTime() + weekDayOffset * 24 * 60 * 60 * 1000
      );
      let costLaborsForDate = await this.getWorkerCostLaborForDate(
        thisDayOfWeek
      );
      costLabors.push(...costLaborsForDate);
    }
    this.loadingWeeklyCostLaborHours = false;
    return costLabors
      .reduce(
        (currentSumOfLaborHours, costLabor) =>
          currentSumOfLaborHours + (costLabor.laborHours ?? 0),
        0
      )
      .toFixed(2);
  }
  private async loadLaborRecords() {
    this.loading = true;
    let date = new Date(this.date);
    this.costLaborRecords = await this.getWorkerCostLaborForDate(date);
    this.loading = false;
    this.laborHoursThisWeek = await this.getTotalLaborHoursThisWeek();
  }

  private async getWorkerCostLaborForDate(date: Date): Promise<CostLabor[]> {
    let tempCostLaborRecords: CostLabor[] = [];

    if (this.performoUser.worker?.workerId) {
      let query = {
        costLaborByWorkerIdQuery: {
          laborWorkerId: this.performoUser.worker?.workerId,
          laborDate: date
        }
      };
      tempCostLaborRecords = await this.api.getWorkerCostLabor(query);
    }
    return tempCostLaborRecords;
  }

  private async loadTcardTypes() {
    this.tcardTypes = await this.api.getTimecardTypeValueList({});
    this.tcardTypes?.splice(this.tcardTypes.indexOf('-'), 1);
  }

  @Watch('editedItem.orderNumber')
  private async validateOrderNum() {
    var orderNumInput = this.$refs.orderNum as HTMLInputElement;
    if (orderNumInput) {
      orderNumInput.setCustomValidity('Enter a valid work order number.');
    }

    if (this.editedItem.tcardRecordType != 'Work Order') {
      this.orderValidation = true;
    } else {
      this.orderValidation = false;
    }

    if (this.editedItem.orderNumber) {
      // get new orderId based on the order number input
      this.orderResponse = await this.ordersApi.queryWorkOrders({
        orderNumber: '==' + this.editedItem.orderNumber
      });
      // check if order exists and is open
      if (this.orderResponse.data && this.orderResponse.data.length === 1) {
        var responseOrderNumber = this.orderResponse.data[0].orderNumber;
        var responseOrderStatus = this.orderResponse.data[0].orderStatus;
        var responseOrderClosedOut = this.orderResponse.data[0].closedOutFlag;
        if (
          responseOrderNumber == this.editedItem.orderNumber &&
          responseOrderStatus != 'Denied' &&
          responseOrderNumber != 'REQ' &&
          responseOrderClosedOut != true
        ) {
          this.editedItem.workorderId = this.orderResponse.data[0].workorderId;
          this.orderValidation = true;
        }
      }
    }

    if (this.orderValidation) {
      orderNumInput.setCustomValidity('');
    }
  }

  private tcardTypeChangeHandler() {
    this.editedItem.orderNumber = '';
    this.editedItem.workorderId = '';
    this.validateOrderNum();
  }

  /* DATES */
  private async handleDateChange(newDate: string) {
    this.date = newDate;
    this.loadLaborRecords();
  }

  private getFirstDayOfWeek(date: Date) {
    let tempDate = new Date(date.getTime());
    let firstDayOfWeek = tempDate.getDate() - tempDate.getDay();
    tempDate.setDate(firstDayOfWeek);
    return tempDate;
  }

  private getLastDayOfWeek(date: Date) {
    let tempDate = new Date(date.getTime());
    let firstDayOfWeek = this.getFirstDayOfWeek(tempDate);
    tempDate.setTime(firstDayOfWeek.getTime() + 6 * 24 * 60 * 60 * 1000);
    return tempDate;
  }
  private decrementDate() {
    var tempDate = new Date(this.date);
    tempDate.setDate(tempDate.getDate() - 1);
    this.date = new Date(tempDate).toISOString().substr(0, 10);
  }

  private incrementDate() {
    var tempDate = new Date(this.date);
    tempDate.setDate(tempDate.getDate() + 1);
    this.date = new Date(tempDate).toISOString().substr(0, 10);
  }

  // date picker accepts string formatted in YYYY-MM-DD
  private getDateInYYYYMMDD(currentDate: Date) {
    // year
    let yyyy = '' + currentDate.getFullYear();

    // month
    let mm = '0' + (currentDate.getMonth() + 1); // prepend 0 // +1 is because Jan is 0
    mm = mm.substr(mm.length - 2); // take last 2 chars

    // day
    let dd = '0' + currentDate.getDate(); // prepend 0
    dd = dd.substr(dd.length - 2); // take last 2 chars

    return yyyy + '-' + mm + '-' + dd;
  }

  @Watch('date')
  private updateDateFormat() {
    this.dateFormatted = this.formatDate(this.date);
    this.handleDateChange(this.date);
  }

  private formatDate(date: string) {
    if (!date) return '';

    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  }

  /* CRUD ACTIONS */
  private async save() {
    if (this.editedItem.orderNumber) {
      // get new orderId based on the order number input
      this.orderResponse = await this.ordersApi.queryWorkOrders({
        orderNumber: this.editedItem.orderNumber
      });
      if (this.orderResponse.data) {
        this.editedItem.workorderId = this.orderResponse.data[0].workorderId;
        this.editedItem.propertyId = this.orderResponse.data[0].propertyId;
      }
    }
    if (!this.editedItem.propertyId) {
      this.editedItem.propertyId = this.currentPropertyId;
    }
    if (this.editedIndex > -1) {
      // EDIT
      if (this.editedItem.costId && this.editedItem.laborDate) {
        try {
          var editedItemResponse = await this.api.editLaborById({
            costId: this.editedItem.costId,
            costLaborEditCommand: {
              costId: this.editedItem.costId,
              tcardRecordType: this.editedItem.tcardRecordType,
              orderNumber: this.editedItem.orderNumber,
              laborHours: this.editedItem.laborHours,
              tcardNotes: this.editedItem.tcardNotes,
              workorderId: this.editedItem.workorderId,
              laborDate: this.getDateAdjustedForUTC(this.editedItem.laborDate)
            }
          });
          this.costLaborRecords[this.editedIndex] = editedItemResponse;
        } catch (err) {
          await handleApiError(err);
        }
      }
    } else {
      // CREATE
      this.editedItem.laborName = this.performoUser.workerVendor;
      this.editedItem.laborDate = new Date(this.date);
      this.cmd = {
        costLaborCreateCommand: this.editedItem
      };
      var newLaborResponse = await this.api.createCostLabor(this.cmd);
      // update DOM before underlying data is updated
      this.costLaborRecords.push(newLaborResponse);
    }
    this.closeForm();
  }

  private editItem(item: CostLabor) {
    this.editedIndex = this.costLaborRecords.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  private async deleteItem(item: CostLabor) {
    this.editedItem = Object.assign({}, item);
    this.editedIndex = this.costLaborRecords.indexOf(item);
    this.deleteDialog = true;
  }

  private async deleteItemConfirm() {
    if (this.editedItem.costId) {
      var costId = this.editedItem.costId;
      try {
        await this.api.deleteLaborById({ costId });
        // update DOM before change in underlying data has been updated
        this.costLaborRecords.splice(this.editedIndex, 1);
        this.closeDeleteDialog();
        await this.loadLaborRecords();
      } catch (err) {
        await handleApiError(err);
      }
    }
  }

  private closeDeleteDialog() {
    this.deleteDialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  private closeForm() {
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    this.loadLaborRecords();
    this.dialog = false;
  }

  /* TABLE HEADERS */
  private get listHeaders() {
    return () => [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'laborDate'
      },
      {
        text: 'Type',
        sortable: false,
        value: 'tcardRecordType'
      },
      {
        text: 'Order #',
        sortable: false,
        value: 'orderNumber'
      },
      {
        text: 'Hours',
        sortable: false,
        value: 'laborHours'
      },
      {
        text: 'Notes',
        sortable: false,
        value: 'tcardNotes'
      },
      {
        text: 'Actions',
        sortable: false,
        value: 'actions'
      }
    ];
  }
}
